export const SHOW_TABBAR = 'show_tabbar';